import { useQuery, type ApolloError } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {
  MODE_OF_EMPLOYMENT,
  PROGRAMME_NAME,
} from '../../../../Application/components';

type GetStudyMode = {
  isFullTime: boolean;
  isPhd: boolean;
  loading: boolean;
  error: ApolloError | undefined;
};

export const useGetApplicationStudyMode = (
  applicationId: string,
): GetStudyMode => {
  const filter = {
    _id: {
      eq: applicationId,
    },
  };
  const { data, loading, error } = useQuery(
    gql`
      query ($filter: ApplicationFilter) {
        applications(filter: $filter) {
          programmeChoice {
            studyMode
            programme
          }
        }
      }
    `,
    {
      variables: { filter },
      skip: !applicationId,
      fetchPolicy: 'network-only',
    },
  );

  const isFullTime: boolean =
    (data?.applications?.[0]?.programmeChoice
      ?.studyMode as MODE_OF_EMPLOYMENT) === MODE_OF_EMPLOYMENT.FULL_TIME;

  const isPhd: boolean =
    (data?.applications?.[0]?.programmeChoice?.programme as PROGRAMME_NAME) ===
    PROGRAMME_NAME.DOCTOR_OF_PHILOSOPHY;

  return { isFullTime, isPhd, loading, error };
};
